import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../context/LangContext';

const content = {
  en: {
    clinic: 'Halo Aesthetics Clinic',
    desc: 'Professional medical aesthetics services to create your perfect look.',
    quickLinks: 'Quick Links',
    about: 'About Us',
    services: 'Services',
    cases: 'Cases',
    blog: 'Blog',
    contact: 'Contact Us',
    contactTitle: 'Contact Info',
    phone: 'Phone: 942-388-1688',
    email: 'Email: info@haloaestheticclinic.com',
    address: '1595 16th Ave Suite 103, Richmond Hill, ON L4B 3N9',
    follow: 'Follow Us',
    wechat: 'WeChat',
    instagram: 'Instagram',
    facebook: 'Facebook',
    youtube: 'YouTube',
    copyright: '© 2025 Halo Aesthetic Clinic. All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
  },
  cn: {
    clinic: 'Halo Aesthetic Clinic',
    desc: '专业医美服务，为您打造完美容颜',
    quickLinks: '快速链接',
    about: '关于我们',
    services: '服务项目',
    cases: '成功案例',
    blog: '博客资讯',
    contact: '联系我们',
    contactTitle: '联系方式',
    phone: '电话：942-388-1688',
    email: '邮箱：info@haloaestheticclinic.com',
    address: '1595 16th Ave Suite 103, Richmond Hill, ON L4B 3N9',
    follow: '关注我们',
    wechat: '微信',
    instagram: 'Instagram',
    facebook: 'Facebook',
    youtube: 'YouTube',
    copyright: '版权所有 © 2025 Halo Aesthetic Clinic',
    privacyPolicy: '隐私政策',
    termsConditions: '条款与条件',
  }
};

const Footer = () => {
  const { lang } = useLang();
  const c = content[lang];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* 诊所信息 */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white">{c.clinic}</h3>
            <p className="text-gray-400">{c.desc}</p>
          </div>

          {/* 快速链接 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{c.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white">
                  {c.about}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white">
                  {c.services}
                </Link>
              </li>
              <li>
                <Link to="/cases" className="text-gray-400 hover:text-white">
                  {c.cases}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white">
                  {c.blog}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white">
                  {c.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* 联系方式 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{c.contactTitle}</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="tel:942-388-1688" className="hover:text-white transition-colors">
                  {c.phone}
                </a>
              </li>
              <li>
                <a href="mailto:info@haloaestheticclinic.com" className="hover:text-white transition-colors">
                  {c.email}
                </a>
              </li>
              <li>{c.address}</li>
            </ul>
          </div>

          {/* 社交媒体 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{c.follow}</h4>
            <div className="flex space-x-4">
              {/* Instagram */}
              <a 
                href="https://www.instagram.com/halo_aesthetic_clinic?igsh=NTNrNDZxdXBnOWdy&utm_source=qr" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-500 transition-colors duration-300"
                aria-label={c.instagram}
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>

              {/* Facebook */}
              <a 
                href="https://www.instagram.com/halo_aesthetic_clinic?igsh=NTNrNDZxdXBnOWdy&utm_source=qr" 
                className="text-gray-400 hover:text-blue-600 transition-colors duration-300"
                aria-label={c.facebook}
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>

              {/* YouTube */}
              <a 
                href="https://www.instagram.com/halo_aesthetic_clinic?igsh=NTNrNDZxdXBnOWdy&utm_source=qr" 
                className="text-gray-400 hover:text-red-600 transition-colors duration-300"
                aria-label={c.youtube}
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* 版权信息 */}
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p className="mb-2">{c.copyright}</p>
          <div className="flex justify-center items-center space-x-4 text-sm">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">
              {c.privacyPolicy}
            </Link>
            <span>|</span>
            <Link to="/terms-conditions" className="hover:text-white transition-colors">
              {c.termsConditions}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 